import { AnimatePresence, motion } from 'motion/react';
import { FormInput, FormInputProps } from '~/components';

export const FormInputSubmit = <V extends string | number>({
  label,
  input,
  isLoading,
}: {
  label?: string;
  input: FormInputProps<V>;
  isLoading: boolean;
}) => {
  return (
    <div className="space-y-4">
      {label && <div>{label}</div>}

      <div className="relative">
        <FormInput className="h-[4.5rem] pr-[4.75rem]" {...input} />

        <motion.button
          className="absolute right-2 top-2 flex h-14 w-14 cursor-pointer select-none items-center justify-center rounded-full bg-muted"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          type="submit"
        >
          <AnimatePresence>
            {!isLoading && (
              <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
                <motion.div
                  initial={{ scale: 0, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  exit={{ scale: 0, opacity: 0 }}
                >
                  <svg
                    className="size-5"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={2}
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"
                    />
                  </svg>
                </motion.div>
              </div>
            )}
          </AnimatePresence>

          <AnimatePresence>
            {isLoading && (
              <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
                <motion.div
                  className="h-6 w-6"
                  initial={{ scale: 0, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1, transition: { delay: 0.1 } }}
                  exit={{ scale: 0, opacity: 0 }}
                >
                  <div className="loader" />
                </motion.div>
              </div>
            )}
          </AnimatePresence>
        </motion.button>
      </div>
    </div>
  );
};
